

// import React, { useState } from "react";
// import { Form, Input, Button, notification } from "antd";
// import {
//   UserOutlined,
//   MailOutlined,
//   PhoneOutlined,
//   MessageOutlined,
//   InstagramOutlined,
// } from "@ant-design/icons";
// import "./Contact.css";
// import contactImage from "../Asset/about3.png";

// function Contact() {
//   const [form] = Form.useForm();
//   const [loading, setLoading] = useState(false);


// const handleSubmit = (values) => {
//   setLoading(true);

//   fetch('https://script.google.com/macros/s/AKfycbyUpTKbhV8i-1HPTkkhL_RccrQkKH7tM6_tPMWECGyy4sq5-KxMppNqsM8-3SuEWbnI/exec', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(values),
//   })
//     .then((res) => res.json())
//     .then((data) => {
//       if (data.result === 'success') {
//         notification.success({
//           message: 'Success',
//           description: 'Your message has been submitted!',
//         });
//         form.resetFields(); 
//       } else {
//         notification.error({
//           message: 'Error',
//           description: data.error || 'Submission failed!',
//         });
//       }
//     })
//     .catch(() => {
//       notification.error({
//         message: 'Error',
//         description: 'Failed to submit your message!',
//       });
//     })
//     .finally(() => setLoading(false));
// };

//    const icons = [<PhoneOutlined />, <MailOutlined />, <InstagramOutlined />, <MessageOutlined />, <UserOutlined />];


//   return (
//     <div className="contact-page">
//       {/* Floating Background Icons */}
//       {/* <div className="icon-shape icon-1"><PhoneOutlined /></div>
//       <div className="icon-shape icon-2"><MailOutlined /></div>
//       <div className="icon-shape icon-3"><InstagramOutlined /></div>
//       <div className="icon-shape icon-4"><UserOutlined /></div>
//       <div className="icon-shape icon-5"><MessageOutlined /></div>
//        */}

//        {Array.from({ length: 10 }).map((_, index) => (
//   <div key={index} className={`icon-shape icon-${index + 1}`}>
//     {icons[index % icons.length]}
//   </div>
// ))}


//       <div className="contact-wrapper">
//         <div className="contact-image-section">
//           <img src={contactImage} alt="contact" />
//         </div>
//         <div className="contact-form-section">
//           <h2>Contact Us</h2>
//           <Form form={form} layout="vertical" name="contactForm" onFinish={handleSubmit}>
//             <Form.Item name="firstName" label="First Name" rules={[{ required: true, message: "Please input your first name!" }]}>
//               <Input prefix={<UserOutlined />} placeholder="First Name" />
//             </Form.Item>

//             <Form.Item name="lastName" label="Last Name" rules={[{ required: true, message: "Please input your last name!" }]}>
//               <Input prefix={<UserOutlined />} placeholder="Last Name" />
//             </Form.Item>

//             <Form.Item name="email" label="Email" rules={[{ required: true, type: "email", message: "Please input a valid email!" }]}>
//               <Input prefix={<MailOutlined />} placeholder="Email" />
//             </Form.Item>

//             <Form.Item name="contactNumber" label="Contact Number" rules={[
//               { required: true, message: "Please input your contact number!" },
//               { pattern: /^\d{10}$/, message: "Contact number must be 10 digits" }
//             ]}>
//               <Input prefix={<PhoneOutlined />} placeholder="Contact Number" maxLength={10} />
//             </Form.Item>

//             <Form.Item name="message" label="Message" rules={[{ required: true, message: "Please input your message!" }]}>
//               <Input.TextArea rows={4} placeholder="Enter your message here..." />
//             </Form.Item>

//             <Form.Item>
//               <Button type="primary" htmlType="submit" block loading={loading}>
//                 Submit
//               </Button>
//             </Form.Item>
//           </Form>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Contact;



import React, { useState } from "react";
import { Form, Input, Button, notification } from "antd";
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  MessageOutlined,
  InstagramOutlined,
} from "@ant-design/icons";
import { motion } from "framer-motion";
import "./Contact.css";
import contactImage from "../Asset/about3.png";

function Contact() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (values) => {
    setLoading(true);

    fetch('https://script.google.com/macros/s/AKfycbyUpTKbhV8i-1HPTkkhL_RccrQkKH7tM6_tPMWECGyy4sq5-KxMppNqsM8-3SuEWbnI/exec', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(values),
    })
      .then(res => res.json())
      .then(data => {
        if (data.result === 'success') {
          notification.success({
            message: 'Success',
            description: 'Your message has been submitted!',
          });
          form.resetFields();
        } else {
          notification.error({
            message: 'Error',
            description: data.error || 'Submission failed!',
          });
        }
      })
      .catch(() => {
        notification.error({
          message: 'Error',
          description: 'Failed to submit your message!',
        });
      })
      .finally(() => setLoading(false));
  };

  const icons = [<PhoneOutlined />, <MailOutlined />, <InstagramOutlined />, <MessageOutlined />, <UserOutlined />];

  return (
    <div className="contact-page">
      {/* Animated Background Icons */}
      {Array.from({ length: 10 }).map((_, index) => (
        <div key={index} className={`icon-shape icon-${index + 1}`}>
          {icons[index % icons.length]}
        </div>
      ))}

      <div className="contact-layout-container">
        {/* Left Image */}
        <motion.div 
          className="contact-image-section"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <img src={contactImage} alt="Contact" />
        </motion.div>

        {/* Right Form */}
        <motion.div 
          className="contact-form-section"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2>Contact Us</h2>
          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item name="firstName" label="First Name" rules={[{ required: true, message: "Please enter your first name!" }]}>
              <Input prefix={<UserOutlined />} placeholder="First Name" />
            </Form.Item>

            <Form.Item name="lastName" label="Last Name" rules={[{ required: true, message: "Please enter your last name!" }]}>
              <Input prefix={<UserOutlined />} placeholder="Last Name" />
            </Form.Item>

            <Form.Item name="email" label="Email" rules={[{ required: true, type: "email", message: "Please enter a valid email!" }]}>
              <Input prefix={<MailOutlined />} placeholder="Email" />
            </Form.Item>

            <Form.Item name="contactNumber" label="Contact Number" rules={[
              { required: true, message: "Please enter your contact number!" },
              { pattern: /^\d{10}$/, message: "Contact number must be 10 digits" }
            ]}>
              <Input prefix={<PhoneOutlined />} placeholder="Contact Number" maxLength={10} />
            </Form.Item>

            <Form.Item name="message" label="Message" rules={[{ required: true, message: "Please enter your message!" }]}>
              <Input.TextArea rows={4} placeholder="Enter your message here..." />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                Submit
              </Button>
            </Form.Item>
          </Form>
        </motion.div>
      </div>
    </div>
  );
}

export default Contact;
